import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function PrivateRoute({ children, requiredRole = null }) {
  const { currentUser, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!currentUser) {
    console.log('PrivateRoute: No currentUser, redirecting to /login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && role !== requiredRole) {
    console.log(`PrivateRoute: Role mismatch. Required: ${requiredRole}, Actual: ${role}. Redirecting...`);
    if (role === 'employee') return <Navigate to="/employee" replace />;
    if (role === 'admin') return <Navigate to="/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default PrivateRoute;
